import PrimaryLayout from "./Layout";
export default PrimaryLayout;